import * as React from "react"
import {connect} from 'react-redux'
import trans from "trans"

import {
    css,
    Toggler,
} from "@bdfx/mergado-ui-kit";
import {SettingsFormType} from "app/types/model-types";
import { selectFormValues } from "app/reducers/form";

import {
    updateInputValue as change,
} from "app/reducers/form";

interface Props {
    change: typeof change
    settingsForm: SettingsFormType
    saveSettingsDebounced: Function
}

class UISettings extends React.Component<Props> {
    constructor(props) {
        super(props)
    }

    render() {
        const items = ['disable_show_overlap', 'disable_wheelzoom', 'disable_helper', 'ask_before_leave']

        return <StyledDiv>
            {items.map(fieldName => <div className={'clickable padding'} key={fieldName}>
                <Toggler
                    name={`settingsForm.${fieldName}`}
                    onLabel={trans(fieldName)}
                    title={trans(fieldName)}
                    onChange={() => this.props.saveSettingsDebounced()}
                />
            </div>)}            
        </StyledDiv>
    }
}

const StyledDiv = css('div')({
    padding: '10px',
    textAlign: 'left',
    ' .padding': {
        padding: '3px',
    }
})

function mapStateToProps(state) {
    return {
        settingsForm: selectFormValues(state,'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
})(UISettings)